import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { subscribe, unsubscribe } from './actions';

export const useSubscription = (visualizationId, panelId) => {
  const dispatch = useDispatch();
  const visualizationPanelValues = useSelector(({ visualizations }) =>
    visualizations.values[visualizationId]?.find((v) => v.panelId === panelId)
  );

  useEffect(() => {
    dispatch(subscribe(visualizationId, panelId));

    return () => {
      dispatch(unsubscribe(visualizationId, panelId));
    };
  }, []);

  const { latestValues, seriesValues, loading, initialLoaded } = visualizationPanelValues || {};
  return {
    latestValues,
    seriesValues,
    loading,
    initialLoaded,
  };
};

export default useSubscription;
